<template>
	<div>
		<div
			class="dropdown-item d-flex"
			href="#"
			@click="goToDetails(item)"
			:class="{ 'read-notification': isNotRead(item) }"
		>
			<img
				:src="item.languages[0].thumbnail.small"
				alt=""
				class="thumbnailImg mt-1"
			/>
			<!-- <div
                    class="thumbnailImg mt-2"
                    :style="{
                      backgroundImage: 'url(' + item.language[0].thumbnail.small + ')'
                    }"
                  ></div> -->
			<div class="pl-3 pt-3">
				<h6 v-if="item.metaData.notification_status">
					{{ item.metaData.notification_status }}
				</h6>
				<p class="mt-1">{{ item.languages[0].name }}</p>
				<!-- <small v-if="item.releaseDate"> {{ getReleaseDate(item) }} </small> -->
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";
export default {
	name: "comingsoon",

	props: ["item"],

	data() {
		return {};
	},

	created() {
		this.parent = "mylist";
		// localStorage.setItem("notifi", JSON.stringify(cart));
	},
	mounted() {},
	methods: {
		goToDetails(current) {
			var dynamicRoute = "";
			if (current.type == "vod") {
				dynamicRoute = "/details/" + current.id + "/" + this.parent;
			} else if (current.type == "Season") {
				dynamicRoute = "/playlistdetails/" + current.id;
			} else if (current.type == "Series") {
				dynamicRoute = "/detailseries/" + current.id;
			}
			this.$router.push("" + dynamicRoute);
			this.updateReadNotification(current.id);
		},

		getReleaseDate(item) {
			if (item.metaData.notification_status == "coming soon") {
				if (item.releaseDate) {
					return moment(item.releaseDate).format("Do MMMM");
				} else {
					return "NA";
				}
			}
			if (item.releaseDate) {
				return moment(item.releaseDate).fromNow();
			} else {
				return "NA";
			}
		},
		updateReadNotification(videoId) {
			let readNotification = localStorage.getItem("readNotification");
			if (readNotification) {
				readNotification = JSON.parse(readNotification);
			} else {
				readNotification = [];
			}
			readNotification.push(videoId);
			localStorage.setItem("readNotification", JSON.stringify(readNotification));
		},
		isNotRead(item) {
			let readNotification = localStorage.getItem("readNotification");
			if (readNotification) {
				readNotification = JSON.parse(readNotification);
				if (readNotification.indexOf(item.id) != -1) {
					return false;
				}
				
			}
			return true;
		},
	},
};
</script>

<style scoped>
.thumbnailImg {
	height: 100px;
	width: 50px;
	background-size: contain;
	background-repeat: no-repeat;
	border-radius: 5px;
	filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.16));
}
.read-notification{
	background-color:#679F3D29;
}
.read-notification:hover{
	background-color:#679F3D29;
}

</style>
